import { Box, Container, Grid, List, ListItem, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material';
import { JSX } from 'react';

interface Step {
  step: string;
  description: string;
}

const HowItWorks = (): JSX.Element => {
  const steps: Step[] = [
    {
      step: 'Sign in with your Google account',
      description: 'Securely link your YouTube subscriptions with just a few clicks.',
    },
    {
      step: 'Create custom groups',
      description:
        'Name and color-code groups to organize channels by topic, creator type, or any category you prefer.',
    },
    {
      step: 'Drag & drop channels into groups',
      description: 'Quickly organize your subscriptions with our intuitive drag-and-drop interface.',
    },
    {
      step: 'Browse by group on any device',
      description: 'Enjoy a cleaner, more organized subscriptions feed that syncs across all your devices.',
    },
  ];

  return (
    <Box
      id="how-it-works"
      sx={{
        py: 10,
        backgroundColor: 'rgba(0,0,0,0.02)',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontWeight: 700,
            mb: 6,
            textAlign: 'center',
          }}
        >
          How Group My Channels Works
        </Typography>

        <Grid container spacing={4} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <List>
              {steps.map((item, index) => (
                <ListItem key={index} alignItems="flex-start" sx={{ mb: 3 }}>
                  <ListItemIcon>
                    <Paper
                      elevation={0}
                      sx={{
                        width: 36,
                        height: 36,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        backgroundColor: 'primary.main',
                        color: 'white',
                        fontWeight: 'bold',
                      }}
                    >
                      {index + 1}
                    </Paper>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
                        {item.step}
                      </Typography>
                    }
                    secondary={item.description}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              component="img"
              src="https://placehold.co/600x400/e4e8f0/5d6b98?text=How+It+Works"
              alt="How Group My Channels organizes YouTube subscriptions"
              sx={{
                width: '100%',
                borderRadius: 4,
                boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                border: '1px solid rgba(0,0,0,0.1)',
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItWorks;
